import { z } from 'zod';
// The read-only validation badge on the BackOps partner view, and the ticket it opens when clicked.
export const partnerValidationStatusSchema = z.object({
    ticketId: z.number(),
    status: z.string(),
});
